
@if (isOpen()) {
<div class="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999] backdrop-blur-sm animate-fade-in" (click)="onBackdropClick($event)">
    <div class="bg-white w-full max-w-3xl h-[85vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden relative m-4 border border-slate-200">
        
        <!-- Header -->
        <div class="p-5 border-b border-gray-200 bg-slate-50 flex justify-between items-center flex-shrink-0">
            <div>
                <h2 class="text-xl font-bold text-slate-800 flex items-center gap-2">
                    <i class="fa-solid fa-file-contract text-blue-600"></i>
                    ข้อตกลงและนโยบาย (Business Agreement)
                </h2>
                <p class="text-xs text-slate-500 mt-1">สำหรับผู้ประกอบการ (For Clinic & Dispensary Owners)</p>
            </div>
            <button (click)="onClose()" class="text-slate-400 hover:text-slate-600 transition-colors">
                <i class="fa-solid fa-times text-2xl"></i>
            </button>
        </div>

        <!-- Tabs -->
        <div class="flex border-b border-gray-200 bg-white flex-shrink-0">
            <button (click)="setTab('tos')" 
                    [class]="'flex-1 py-3 text-sm font-bold text-center border-b-2 transition-colors ' + (activeTab() === 'tos' ? 'border-blue-600 text-blue-700 bg-blue-50/50' : 'border-transparent text-slate-500 hover:bg-slate-50')">
                ข้อกำหนดการให้บริการ (Terms of Service)
            </button>
            <button (click)="setTab('privacy')" 
                    [class]="'flex-1 py-3 text-sm font-bold text-center border-b-2 transition-colors ' + (activeTab() === 'privacy' ? 'border-emerald-600 text-emerald-700 bg-emerald-50/50' : 'border-transparent text-slate-500 hover:bg-slate-50')">
                นโยบายความเป็นส่วนตัว (Privacy Policy)
            </button>
        </div>

        <!-- Content (Scrollable) -->
        <div class="flex-grow overflow-y-auto p-8 text-sm text-slate-700 leading-relaxed">
            
            @if (activeTab() === 'tos') {
                <div class="space-y-6">
                    <div class="mb-4">
                        <h3 class="text-lg font-bold text-slate-900 mb-2">ข้อกำหนดและเงื่อนไขการใช้งานแพลตฟอร์ม</h3>
                        <p class="text-slate-500 text-xs">ฉบับปรับปรุงล่าสุด: มิถุนายน 2568</p>
                    </div>

                    <div class="space-y-4">
                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">1. สถานะของผู้ให้บริการ</h4>
                            <p>CHUAMKAN เป็นเพียงผู้ให้บริการซอฟต์แวร์ (Software-as-a-Service) ไม่มีส่วนเกี่ยวข้องกับการประกอบวิชาชีพเวชกรรม การจำหน่ายยาเสพติดให้โทษ หรือการให้คำแนะนำทางการแพทย์โดยตรง</p>
                        </section>

                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">2. การใช้งาน AI และระบบอัตโนมัติ</h4>
                            <p>ระบบมีการใช้งานปัญญาประดิษฐ์ (AI) ในการอ่านข้อมูลบัตรประชาชน (OCR) และช่วยบันทึกข้อมูลทางการแพทย์ (Medical Scribe)</p>
                            <ul class="list-disc list-inside pl-2 mt-1 space-y-1 text-slate-600">
                                <li>ผู้ใช้งานรับทราบว่า AI อาจมีความผิดพลาด (Error Rate) และต้องตรวจสอบความถูกต้องของข้อมูลทุกครั้งก่อนการบันทึกหรืออนุมัติ</li>
                                <li>แพลตฟอร์มไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดจากการไม่อนุมัติ (Reject) หรือการวินิจฉัยของแพทย์ที่อ้างอิงข้อมูลจาก AI เพียงอย่างเดียว</li>
                            </ul>
                        </section>

                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">3. กระเป๋าเงินและเครดิต (Wallet & Billing)</h4>
                            <ul class="list-disc list-inside pl-2 mt-1 space-y-1 text-slate-600">
                                <li>ระบบใช้โมเดล "Pay-on-Success" โดยจะหักเครดิตเมื่อเคสได้รับการอนุมัติ (Status: APPROVED) เท่านั้น</li>
                                <li>เครดิตใน Wallet ที่เติมเข้ามาถือเป็นการชำระค่าบริการล่วงหน้า และ <strong>ไม่สามารถขอคืนเป็นเงินสดได้ (Non-refundable)</strong> เว้นแต่เป็นความผิดพลาดของระบบที่พิสูจน์ได้</li>
                                <li>หากเครดิตไม่เพียงพอ ระบบมีสิทธิ์ระงับการให้บริการ (Freeze Service) ในฟังก์ชันที่เกี่ยวข้องทันที เช่น การส่งตัวผู้ป่วย หรือการอนุมัติเคส</li>
                            </ul>
                        </section>

                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">4. เครือข่ายพันธมิตร (Partner Network)</h4>
                            <p>การเชื่อมต่อระหว่าง "ร้านยา" และ "คลินิก" เป็นความตกลงทางธุรกิจระหว่างผู้ใช้งานด้วยกันเอง แพลตฟอร์มทำหน้าที่เป็นเพียงตัวกลางในการส่งผ่านข้อมูลและเคลียร์ยอดเงินตามคำสั่งเท่านั้น ไม่มีส่วนรับผิดชอบต่อหนี้สินหรือข้อพิพาทระหว่างคู่สัญญา</p>
                        </section>
                        
                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">5. การปฏิบัติตามกฎหมาย (Compliance)</h4>
                            <p>ผู้ใช้งานยืนยันว่ามีใบอนุญาตประกอบกิจการถูกต้องตามกฎหมายที่เกี่ยวข้อง (พ.ร.บ. สถานพยาบาล, พ.ร.บ. ยาเสพติดให้โทษ) หากแพลตฟอร์มตรวจพบการใช้งานที่ผิดกฎหมาย (เช่น การออกใบรับรองเท็จ) ขอสงวนสิทธิ์ในการระงับบัญชีถาวรทันทีโดยไม่ต้องแจ้งล่วงหน้า</p>
                        </section>
                    </div>
                </div>
            } @else {
                <div class="space-y-6">
                    <div class="mb-4">
                        <h3 class="text-lg font-bold text-slate-900 mb-2">นโยบายความเป็นส่วนตัว (สำหรับผู้ประกอบการ)</h3>
                        <p class="text-slate-500 text-xs">เพื่อให้สอดคล้องกับ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)</p>
                    </div>

                    <div class="space-y-4">
                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">1. บทบาทของเรา (Our Role)</h4>
                            <p>ภายใต้กฎหมาย PDPA บริษัททำหน้าที่เป็น <strong>"ผู้ประมวลผลข้อมูลส่วนบุคคล" (Data Processor)</strong> ที่ดำเนินการตามคำสั่งของท่านซึ่งเป็น <strong>"ผู้ควบคุมข้อมูลส่วนบุคคล" (Data Controller)</strong></p>
                        </section>

                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">2. ข้อมูลที่เราเก็บรวบรวม</h4>
                            <ul class="list-disc list-inside pl-2 mt-1 space-y-1 text-slate-600">
                                <li><strong>ข้อมูลธุรกิจ:</strong> ชื่อร้าน, ที่อยู่, เลขใบอนุญาต, เลขบัญชีธนาคาร (สำหรับการโอนเงิน Clearing)</li>
                                <li><strong>ข้อมูลบุคลากร:</strong> ชื่อ, อีเมล, เบอร์โทรศัพท์, รหัส PIN, ลายเซ็นอิเล็กทรอนิกส์แพทย์</li>
                                <li><strong>ข้อมูลคนไข้:</strong> (เก็บรวบรวมในนามของท่าน) ประวัติการรักษา, ภาพถ่าย, ข้อมูลบัตรประชาชน</li>
                            </ul>
                        </section>

                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">3. การส่งต่อข้อมูลให้บุคคลที่สาม</h4>
                            <p>เพื่อให้ระบบทำงานได้สมบูรณ์ ข้อมูลบางส่วนจะถูกประมวลผลโดยบริการภายนอก:</p>
                            <ul class="list-disc list-inside pl-2 mt-1 space-y-1 text-slate-600">
                                <li><strong>Google Gemini (AI):</strong> ใช้ประมวลผลรูปภาพและข้อความ (ไม่มีการนำข้อมูลไปฝึกฝนโมเดลต่อ)</li>
                                <li><strong>Omise / Payment Gateway:</strong> ใช้ประมวลผลการชำระเงิน</li>
                                <li><strong>Cloud Infrastructure (Supabase):</strong> ใช้จัดเก็บฐานข้อมูล (เข้ารหัสมาตรฐาน AES-256)</li>
                            </ul>
                        </section>

                        <section>
                            <h4 class="font-bold text-slate-800 mb-1">4. สิทธิ์ในการเข้าถึงข้อมูล (Data Access)</h4>
                            <p>เพื่อความปลอดภัย ข้อมูลคนไข้ของร้านท่านจะไม่ถูกเปิดเผยแก่ร้านค้าอื่นในระบบ เว้นแต่กรณีที่มีการ <strong>"ส่งตัว" (Referral)</strong> ซึ่งถือว่าท่านได้ขอความยินยอมจากคนไข้ในการส่งต่อข้อมูลไปยังคลินิกปลายทางแล้ว</p>
                        </section>
                    </div>
                </div>
            }
        </div>

        <!-- Footer -->
        <div class="p-4 border-t border-gray-200 bg-slate-50 flex justify-end">
            <button (click)="onClose()" class="px-6 py-2.5 bg-slate-800 text-white font-bold rounded-lg hover:bg-slate-700 transition-colors shadow-lg">
                ปิดหน้าต่าง (Close)
            </button>
        </div>
    </div>
</div>
}
